export default function Tab({ name, title, hide, children }) {

    return (
        hide
            ? null
            :
            <div className = "tab" name = { name }>
                { children }
            </div>
    );
}